export default "__VITE_ASSET__1a27797b__"